import { OrderCancelReasonEnum, OrderStatusEnum, OrderTypeEnum } from '../../types';

export const TransOrderType = {
  [OrderTypeEnum.Market]: 'Market',
  [OrderTypeEnum.Limit]: 'Limit',
  [OrderTypeEnum.StopLimit]: 'Stop limit',
  [OrderTypeEnum.StopMarket]: 'Stop market',
  [OrderTypeEnum.Liquidation]: 'Liquidation',
  [OrderTypeEnum.Settlement]: 'Settlement',
  [OrderTypeEnum.Invalid]: 'Invalid',
  [OrderTypeEnum.Takeover]: 'Invalid',
  [OrderTypeEnum.TakeoverSettlement]: 'Invalid',
} as const;

export const TransOrderStatus = {
  [OrderStatusEnum.New]: 'Open',
  [OrderStatusEnum.PendingNew]: 'Pending open',
  [OrderStatusEnum.PartiallyFilled]: 'Part. filled',
  [OrderStatusEnum.Filled]: 'Completed',
  [OrderStatusEnum.Canceled]: 'Canceled',
  [OrderStatusEnum.Rejected]: 'Rejected',
  [OrderStatusEnum.Invalid]: 'Invalid',
} as const;

export const TransOrderCancelReason: Record<string, string> = {
  [OrderCancelReasonEnum.PostOnly]: 'Post only',
  [OrderCancelReasonEnum.ReduceOnly]: 'Reduce only',
  [OrderCancelReasonEnum.Immediate]: 'IOC',
  [OrderCancelReasonEnum.Supervisory]: 'Flipster',
};
